import Player from '@vimeo/player'

export const selector = '.video-controls'

export default (
    el = null
) => {
    if (!el)
        return

    const section = el.closest('section')

    if (!section)
        return

    console.groupCollapsed('Video Controls')

    const iframe = section
        .querySelector('iframe')

    const video = section
        .querySelector('video')

    const vimeo = iframe
            && iframe.src.includes('vimeo')
        ? new Player(iframe)
        : null

    const btn = el
        .querySelector('button')

    const toggleBtn = () => btn
        .classList.toggle('video-controls-paused')

    const videoCtrl = () => {
        video.paused
            ? video.play()
            : video.pause()

        toggleBtn()
    }

    const vimeoCtrl = () => {
        vimeo.getPaused().then((paused) => {
            paused
                ? vimeo.play()
                : vimeo.pause()
        }).catch((error) => {
            console.error('Error checking playback state:', error)
        })

        toggleBtn()
    }

    if ((video || vimeo) && btn)
        btn.addEventListener('click', () => {
            video
                ? videoCtrl()
                : vimeoCtrl()
        })

    // Log instance
    console.log(el)

    console.groupEnd()

    return el
}
